import axios from 'axios';
import util from '../store/utils'

// axios全局配置
axios.defaults.baseURL = window.location.origin;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export default class nswHttp {
    /**
     * 通用发送请求
     * @param params
     * @param isRaw 是否取原始数据
     * @returns {Promise}
     */
    static httpSend(params, isRaw) {
        //每次都会去查token是不是存在的,防止刷新数据丢失
        axios.defaults.headers.common['Authorization'] = util.runAuth('get') || '';

        return new Promise((resolve, reject) => {
            axios(params).then(res => {
                if (isRaw) {
                    resolve(res);
                } else {
                    let data = res.data;
                    if (data.isSuccess) {
                        resolve(data.data);
                    } else {
                        reject(data.message || data.error);
                    }
                }
            }, error => {
                let status = error.request.status;
                this.validateLogin(status);
                let data = error.request.responseText;
                try {
                    data = JSON.parse(data);
                } catch (err) {
                    data = {message:'未知错误'};
                }
                reject(data.message || data.error);
            });
        });
    }

    static validateLogin(status) {
        switch (status) {
            case 401:
                window.location.href = axios.defaults.baseURL + '/#/relogin';
                break;
        }
    }

    static httpGet(url, params, isRaw) {
        return this.httpSend({
            method: 'get',
            url: url,
            params: params,
            // timeout:10
        }, isRaw);
    }

    static httpPost(url, data, isRaw) {
        return this.httpSend({
            method: 'post',
            url: url,
            data: data
        }, isRaw);
    }

    static httpPut(url, data, isRaw) {
        return this.httpSend({
            method: 'put',
            url: url,
            data: data
        }, isRaw);
    }

    static httpDelete(url, params, isRaw) {
        return this.httpSend({
            method: 'put',
            url: url,
            params: params
        }, isRaw);
    }

    static getBaseUrl() {
        return axios.defaults.baseURL;
    }
}



// WEBPACK FOOTER //
// ./app/api/http.js